module.exports = __webpack_public_path__ + "static/media/leftArrow.84522f91.svg";